import * as React from 'react';
import LoginPageView from '../layouts/LoginPageView';
import { Snackbar } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export interface LoginPageProps {
  onComponentDidMount: () => void;
  onSubmit: () => void;
  saveUserName: (username: string) => void;
  savePassword: (password: string) => void;
  goAdminPortal: () => void;
  goDesignerPortal: () => void;
  btnElement: string;
  btnType: string;
  errorMessage: string;
  errorBar: boolean;
  successMessage: string;
  successBar: boolean;
  close: boolean;
  handleClose: () => void;

  username: string;
  password: string;
}

class LoginPage extends React.Component<LoginPageProps> {
  render() {
    return (
      <div>
        <LoginPageView
          onSubmit={this.props.onSubmit}
          savePassword={this.props.savePassword}
          saveUsername={this.props.saveUserName}
          username={this.props.username}
          password={this.props.password}
          goAdminPortal={this.props.goAdminPortal}
          goDesignerPortal={this.props.goDesignerPortal}
        />
        <Snackbar
          open={this.props.errorBar}
          autoHideDuration={2000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="error"
          >
            <AlertTitle>Error</AlertTitle>
            {this.props.errorMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          open={this.props.successBar}
          autoHideDuration={2000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="success"
          >
            <AlertTitle>Login Successfully</AlertTitle>
            {this.props.successMessage}
          </Alert>
        </Snackbar>
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/login/LoginPage.tsx